import { SanityShippingTooltips } from '../../graphql/gatsby'
import { CartFragment } from '../../graphql/magento'

type ShippingAddress = NonNullable<NonNullable<CartFragment['shipping_addresses']>[number]>
export type ShippingMethod = NonNullable<
  | NonNullable<ShippingAddress['available_shipping_methods']>[number]
  | ShippingAddress['selected_shipping_method']
>
export type SanityShippingTooltipKey = Exclude<
  keyof SanityShippingTooltips,
  '_key' | '__typename' | '_type'
>

export function isShippingMethodEqual(methodA: ShippingMethod, methodB: ShippingMethod): boolean {
  return (
    methodA.carrier_code === methodB.carrier_code && methodA.method_code === methodB.method_code
  )
}

/**
 * Select shipping tooltip key to display for shipping method
 */
export const shippingTooltipKeyFromMethod =
  (isPricingProfessional: boolean) =>
  (method: Pick<ShippingMethod, 'method_code'>): SanityShippingTooltipKey | undefined => {
    switch (method.method_code?.toUpperCase()) {
      case 'FREESHIPPING':
      case 'FLATRATE':
        return isPricingProfessional ? 'standardProfessional' : 'standardPatient'
      case 'FEDEX_2_DAY':
      case 'STANDARD_OVERNIGHT':
      case 'PRIORITY_OVERNIGHT':
        return isPricingProfessional ? 'expeditedProfessional' : 'expeditedPatient'
      default:
        return undefined
    }
  }
